module.exports = __webpack_public_path__ + "static/media/protein-scoop-white.6785b703.jpg";